import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_ORDER_HISTORY_SUCCESS:
      return [...action.orderHistory];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/reducers/order-history.js